export default __webpack_public_path__ + "static/gs-4-copysnidbit--mobile-e4a2c7cb74e556d24d61ade1000e5ab6.webp";